"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = exports.BackButton = exports.Icon = exports.TypographyEntio = exports.ToolBarEntio = exports.Title = void 0;
const styled_components_1 = require("styled-components");
const core_1 = require("@material-ui/core");
const ArrowBack_1 = require("@material-ui/icons/ArrowBack");
exports.Title = styled_components_1.default(core_1.AppBar) `
    background-color: #e95b26;
`;
exports.ToolBarEntio = styled_components_1.default(core_1.Toolbar) `
    background-color: #e95b26;
`;
exports.TypographyEntio = styled_components_1.default(core_1.Typography) `
    flex-grow: 1;
`;
exports.Icon = styled_components_1.default(core_1.IconButton) `
    margin-left: 15%;
`;
exports.BackButton = styled_components_1.default(ArrowBack_1.default) ``;
exports.Logo = styled_components_1.default.img `
    max-width: 90%;
    position: absolute;
`;
//# sourceMappingURL=TitleBarStyle.js.map